import { underscore } from '@ember/string';

/**
 * Returns a new object with the same camelCase keys and values, plus snake_case
 * keys with the same values (e.g. insuranceFrontUpload → insurance_front_upload).
 * Useful when a payload must be sent with both naming conventions.
 *
 * @param {Object} obj - Object with camelCase keys
 * @returns {Object} New object with both camelCase and snake_case keys
 */
export default function withSnakeCaseKeys(obj) {
  let result = { ...obj };
  for (let key of Object.keys(obj)) {
    result[underscore(key)] = obj[key];
  }
  return result;
}
